import moment from "moment-timezone";

const useWeekdayFormat = () => {
  const niceWeekday=(date: string | number | Date)=> {
    const d = new Date(date);
    const dm = moment(d);
    const day = dm.format("dddd");
    return day.toUpperCase();
  };
  return {
    niceWeekday,
  };
};
export default useWeekdayFormat;
